/**
 * Showcases Module Routes
 *
 * Route definitions for the Showcases module.
 */

import type { RouteRecordRaw } from 'vue-router'
import ModuleLayout from '@/layouts/ModuleLayout.vue'

const routes: RouteRecordRaw[] = [
    {
        path: '/showcases',
        component: ModuleLayout,
        meta: {
            moduleKey: 'showcases',
        },
        children: [
            {
                path: '',
                name: 'showcases-list',
                component: () => import('./views/ShowcaseList.vue'),
                meta: {
                    title: 'All Showcases',
                },
            },
            {
                path: 'create',
                name: 'showcases-create',
                component: () => import('./views/ShowcaseCreate.vue'),
                meta: {
                    title: 'Add Showcase',
                    moduleKey: 'showcases',
                },
            },
            {
                path: 'analytics',
                name: 'showcases-analytics',
                component: () => import('./views/AnalyticsDashboard.vue'),
                meta: {
                    title: 'Showcase Analytics',
                },
            },
            {
                path: ':id',
                name: 'showcases-detail',
                component: () => import('./views/ShowcaseDetail.vue'),
                meta: {
                    title: 'Showcase Details',
                },
            },
        ],
    },
]

export default routes
